import {
  UPDATE_USER_INFO,
  CLEAR_USER_INFO,
  UPDATE_ACCESS_PERMISSION
} from '../actions/user'
import { USER } from '../constants/keyStorage'
import getRole from '../utils/getRole'

const initState = (function() {
  const userStorage = JSON.parse(localStorage.getItem(USER))
  if (userStorage) {
    userStorage['accessPermissions'] = getRole(userStorage.roles)
  }
  return (
    userStorage || {
      accessToken: ''
    }
  )
})()

export default function(state = initState, action) {
  switch (action.type) {
    case UPDATE_USER_INFO: {
      if (action.user) localStorage.setItem(USER, JSON.stringify(action.user))
      return {
        ...state,
        ...action.user
      }
    }
    case CLEAR_USER_INFO: {
      localStorage.removeItem(USER)
      return {
        accessToken: ''
      }
    }
    case UPDATE_ACCESS_PERMISSION: {
      return {
        ...state,
        accessPermissions: getRole(action.roles)
      }
    }
    default:
      return state
  }
}
